import DashboardProblemContent from "./DashboardProblemContent";
import Respond from "./Respond";

function ProblemContent(props) {
    const {problems, errors, problem_index, limit, showMore, message, handleChange, submitResponse, getResponse, loading, page, index_counter, responded_problems_count} = props
    const {count} = problems || '';
    if (count > 0)
    return (
        <div className="problem-content top-buffer">
            <DashboardProblemContent 
                problems={problems}
                problem_index={problem_index}
                limit={limit}
                showMore={showMore}  
                loading={loading}
                page={page}
                index_counter={index_counter}
                responded_problems_count={responded_problems_count}
            />
            <Respond 
                errors = {errors}
                message={message}
                handleChange={handleChange}
                submitResponse={submitResponse}
                getResponse={getResponse}
                responded_problems_count={responded_problems_count}
            />
        </div>
    )
}

export default ProblemContent;

